import React, { FC, useState } from "react";
import { EditableWaitlistViewModel } from "../../Blocks/Waitlist/EditableWaitlistViewModel.csharp";
import classNames from "classnames";
import { WaitWhileApi } from "../Api/WaitWhileApi";
import { UpdateWaitlistRequestDto } from "../../../Api/Model/UpdateWaitlistRequestDto.csharp";
import { WaitlistTimeSelect } from "./WaitlistTimeSelect";
import { WaitlistSubmitButton } from "./WaitlistSubmitButton";
import { Collapse } from "react-collapse";
import { UpdateWaitlistConfirmationModal } from "./UpdateWaitlistConfirmationModal";

export const EditableWaitlist: FC<EditableWaitlistViewModel> = (waitlist) => {
  const [waitlistState, setWaitlistState] = useState(waitlist);
  const [openHour, setOpenHour] = useState(
    waitlist.todaysOpeningRegistrationHour
  );
  const [closeHour, setCloseHour] = useState(
    waitlist.todaysClosingRegistrationHour
  );
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [requestFailed, setRequestFailed] = useState(false);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reasons, setReasons] = useState<string[]>([]);
  const [additionalReason, setAdditionalReason] = useState<string>();
  const [alert, setAlert] = useState(waitlist.isAlertAvailable);

  const api = new WaitWhileApi();

  const updateWaitlist = async (request: UpdateWaitlistRequestDto) => {
    setRequestInProgress(true);
    setRequestFailed(false);
    try {
      const response = await api.updateWaitlist(request);
      setWaitlistState(response);
    } catch {
      setRequestFailed(true);
    }

    setRequestInProgress(false);
  };

  const onOpenCloseSubmit = async () => {
    const changeReasons = [...reasons];
    if (additionalReason) {
      changeReasons.push(additionalReason);
    }
    if (!changeReasons || changeReasons.length == 0) {
      changeReasons.push("ikke oppgitt");
    }

    const request = {
      waitlistId: waitlistState.contentId,
      dashboardId: waitlistState.protectedDashboardPageId,
      userName: waitlistState.userName,
      closeTodaysRegistration: !waitlistState.closeTodaysRegistration,
      openHour: undefined,
      closeHour: undefined,
      changeReasons,
      alert,
    };
    await updateWaitlist(request);
    setReasons([]);
  };

  const toggleTodaysRegistration = async () => {
    setIsModalOpen(true);
  };

  const updateHours = async () => {
    const request = {
      waitlistId: waitlist.contentId,
      dashboardId: waitlist.protectedDashboardPageId,
      userName: waitlist.userName,
      openHour,
      closeHour,
      closeTodaysRegistration: undefined,
      alert: false,
      changeReasons: [],
    };
    await updateWaitlist(request);
  };

  const toggleTodaysRegistrationText = waitlistState.closeTodaysRegistration
    ? waitlist.editableWaitlistLabels.openButtonLabel
    : waitlist.editableWaitlistLabels.closeButtonLabel;
  const updateHoursText =
    waitlist.editableWaitlistLabels.updateHoursButtonLabel;
  
  const toggleReason = (value: string) => {
    if (reasons.indexOf(value) === -1) {
      setReasons([...reasons, value]);
    } else {
      setReasons(reasons.filter(r => r !== value));
    }
  }

  return (
    <div className="card theme-inherit-light h-100">
      <div className="card-body d-flex flex-column">
        <h3>{waitlist.name}</h3>
        <p className="fs-6 mb-3">
          <span className={classNames("fw-bold", "fs-5")}>
            {waitlistState.openingRegistrationCurrentStatus}
          </span>
          <span>
            {" | "}
            {waitlistState.openingRegistrationNextStatus}
          </span>
        </p>

        <WaitlistSubmitButton
          text={toggleTodaysRegistrationText}
          onClick={toggleTodaysRegistration}
          requestInProgress={requestInProgress}
          isPrimary
        />

        <p className="fs-6 mt-3">
          <button
            className="accordion-toggler__label"
            aria-expanded={isAccordionOpen}
            onClick={() => setIsAccordionOpen(!isAccordionOpen)}
            type="button"
          >
            {waitlist.editableWaitlistLabels.manageRegistrationHoursHeading}
          </button>
        </p>
        <Collapse
          theme={{ collapse: "react-collapse--collapse" }}
          isOpened={isAccordionOpen}
        >
          <WaitlistTimeSelect
            disabled={requestInProgress}
            label={waitlist.editableWaitlistLabels.registrationOpenHourLabel}
            value={openHour}
            onChange={setOpenHour}
          />
          <WaitlistTimeSelect
            disabled={requestInProgress}
            label={waitlist.editableWaitlistLabels.registrationCloseHourLabel}
            value={closeHour}
            onChange={setCloseHour}
          />
          <WaitlistSubmitButton
            text={updateHoursText}
            onClick={updateHours}
            requestInProgress={requestInProgress}
          />
        </Collapse>

        {requestFailed && (
          <span className="Form__Element__ValidationError">
            {waitlist.editableWaitlistLabels.failMessageHeading}
          </span>
        )}
      </div>
      <UpdateWaitlistConfirmationModal
        onClose={() => setIsModalOpen(false)}
        onSubmit={onOpenCloseSubmit}
        isOpen={isModalOpen}
        reasons={reasons}
        toggleReason={toggleReason}
        setAdditionalReason={setAdditionalReason}
        alert={alert}
        setAlert={setAlert}
        waitlist={waitlistState}
      />
    </div>
  );
};
